import React from 'react';

// svg
// import logoTwo from '../Assets/compass-logo-2.svg';
import woman from '../Assets/woman.svg';
import flower from '../Assets/flower.svg'

const SuccessTwo:React.FC = () => {

  return (
    <section className='bg-white w-full h-[100vh] flex items-center justify-center'>
      <div className='container flex items-center justify-center'>
        <div className='w-full md:w-[92%] lg:w-full h-[542.56px] relative p-4 pb-6 bg-white overflow-hidden flex items-center'>
          <div className='gap-3 w-full'>
            <h2 className='text-[30px] md:text-[2em] text-[#023527] font-bold text-center mb-3'>A mail has been sent to you. <br /> Click the link to reset your password.</h2>
          </div>
          <img className='hidden w-[170px] lg:w-[230px] md:block absolute -left-4 -bottom-4 lg:bottom-0' src={flower} alt='Anim' />
          <img className='hidden w-[210px] lg:w-[250px] md:block absolute -right-4 -bottom-4 lg:bottom-0' src={woman} alt='Anim' />
        </div>
      </div>
    </section>
  )
}

export default SuccessTwo